<template>

    <div
        class="wrapperForm"
    >
        <v-row 
            no-gutters
        >

            <v-col cols="12" sm="12" md="12" class="section-wrapper">
                <v-card
                    flat
                >
                    <v-card-text>

                        <div class="form-box-title title-with-right-part">
                            <span>
                                {{ $t("Номенклатура") }}
                            </span>
                            <div class="twrp-content">
                                <v-text-field
                                    :value="search"
                                    @input="updateSearch($event)"
                                    :placeholder="$t('Поиск')"
                                    hide-details
                                    dense
                                    clearable
                                    required
                                    @click:clear="search=''"
                                    class="twrp-search"
                                    append-icon="fas fa-search"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="d-flex" v-if="years.length > 0">
                            <div class="status-panel-into-section-after-title-label">{{$t('Год')}}</div>
                            <div class="status-panel status-panel-into-section-after-title">
                                <v-chip-group
                                    v-model="year"
                                    active-class="active-panel-item"
                                    mandatory
                                >
                                    <v-chip
                                        v-for="(item, index) in years"
                                        :key="index"
                                        :value="item"
                                        class="ma-1"
                                        small
                                        label
                                    >
                                        {{ item }}
                                    </v-chip>
                                </v-chip-group>
                            </div> 
                        </div>   

                        <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items="entities"
                            :options.sync="options"
                            :server-items-length="total"
                            :items-per-page="10"
                            :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                            :page.sync="options.page"
                            @page-count="paginationPageCount = $event"
                            class="elevation-1 customization-list-table pagination-list-table sticky-table"
                            @dblclick:row="(event, data) => onRowClick({ id: data.item.id })"
                        >

                            <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                            <template v-slot:[`item.header`]="{ item }">
                                <div class="elipsis-text-wrap">
                                    <div class="etw-text-container">
                                        <div class="etw-text" v-tooltip.top-center="item.header">
                                            {{item.header}}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`item.doctype`]="{ item }">
                                <div class="elipsis-text-wrap">
                                    <div class="etw-text-container">
                                        <div class="etw-text" v-tooltip.top-center="item.doctype">
                                            {{item.doctype}}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`item.countername`]="{ item }">
                                <div class="elipsis-text-wrap">
                                    <div class="etw-text-container">
                                        <div class="etw-text" v-tooltip.top-center="item.countername">
                                            {{item.countername}}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`item.lifeperiod`]="{ item }">
                                <div class="elipsis-text-wrap">
                                    <div class="etw-text-container">
                                        <div class="etw-text" v-tooltip.top-center="item.lifeperiod">
                                            {{item.lifeperiod}}
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <template v-slot:[`footer.prepend`]>
                                <v-pagination
                                    v-model="options.page"
                                    :length="paginationPageCount"
                                    :total-visible="$listPaginationTotal"
                                    color="teal"
                                ></v-pagination>
                            </template>

                        </v-data-table>

                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>        
    </div>

</template>

<script>
import i18n from '@/i18n';
import _ from 'lodash';
import { httpAPI } from "@/api/httpAPI";
import { mapActions } from 'vuex';

export default {
    name: "Nomenclatures",
    columnIndex: {
        'code': 2,
        'header': 3,
        'doctype': 4,
        'countername': 5,
        'lifeperiod': 6
    },
    props: {
        enterpriseId: {
            type: String,
            default: null
        }
    },
    asyncComputed: {
        years: {
            async get() {
                let response = await httpAPI({
                    url: `api/settings/filter?collection=Chancellery.Nomenclature&entid=${this.enterpriseId}`,
                    method: 'GET'
                });

                let years = response?.data.payload?.Years?.filter(x => x[0] !== '-1').map(x => parseInt(x[0])) ?? [];
                return _(years).sortBy().value().reverse();
            },
            default: [],
            lazy: true
        }
    },
    computed: {
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                Year : this.year
            }
        },
    },
    data: () => ({
        headers: [
            { text: i18n.t("Индекс"), value: 'code', width: '150px' },
            { text: i18n.t("Наименование"), value: 'header' },
            { text: i18n.t("Тип_документа"), value: 'doctype', width: '10%' },
            { text: i18n.t("Журнал"), value: 'countername', width: '10%'},
            { text: i18n.t("Срок"), value: 'lifeperiod', width: '10%'}
        ],
        loading: false,
        total: 0,
        entities: [],
        search: '',
        year: null,
        options: {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "code" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
        paginationPageCount: 0
    }),
    methods: {
        ...mapActions(['setOverlayVisible']),
        async onRowClick(eventData) {
            try
            {
                this.setOverlayVisible({ visible: true });
                await this.$router.push({ name: 'Nomenclature', query: { id: eventData.id }, params: { id: eventData.id, enterpriseId: this.enterpriseId } });
            }
            catch (err)
            {
                console.warn(err);
            }
            finally
            {
                this.setOverlayVisible({ visible: false });
            }
        },
        updateSearch: _.debounce(function(v) {
            if (v !== null)
                this.search = v;
        }, 500),
        async getData() {
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/settings/list?collection=Chancellery.Nomenclature&entid=${this.enterpriseId}&filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET'
            });

            this.entities = response?.data?.payload?.data ?? [];
            this.total = response?.data?.payload?.total ?? 0;
            this.loading = false;
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, Year } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "code" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 2;

            return {
                SearchStr,
                Year: !Year || Year === "All" ? "" : Year,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage
            };
        },
    },
    watch: {
        filter: {
            async handler(newVal, oldVal) {
                if (!this.$_.isEqual(newVal, oldVal)) {
                    console.log('filter changed');
                    await this.getData();
                }
            },
            deep: true,
        },
    }
}
</script>